import { ClientDashboardAccessPage } from "./client.types";


export const CLIENT_PERMISSIONS_OPTIONS: ClientDashboardAccessPage[] = [
  {
    name: 'Reporting',
    value: 'reporting',
    description: 'View reporting data',
    tabs: [
      {
        name: 'Reporting',
        value: 'reporting-dashboard',
        description: 'View reporting data',
        permissions: [],
      },
    ],
  },
  {
    name: 'Surveys',
    value: 'surveys',
    description: 'View surveys and manage surveys',
    tabs: [
      {
        name: 'List Surveys',
        value: 'list-surveys',
        requires: ['create-surveys', 'results-surveys'],
        description: 'View surveys you have access to in a table',
        permissions: [],
      },
      {
        name: 'Create Surveys',
        value: 'create-surveys',
        requires: ['list-surveys', 'results-surveys'],
        description: 'Create surveys',
        permissions: [
          {
            name: 'Generate Survey',
            value: 'generate-surveys',
            description: 'Use AI to generate surveys',
          },
        ],
      },
      {
        name: 'Survey Results',
        value: 'results-surveys',
        description: 'View survey results',
        requires: ['list-surveys'],
        permissions: [
          {
            name: 'AI Panel',
            value: 'panel-surveys',
            description: 'Can have AI panelists answer surveys',
            requires: ['list-surveys'],
          },
        ],
      },
      {
        name: 'Trends',
        value: 'trends-surveys',
        description: 'View trends for survey results',
        requires: ['results-surveys', 'list-surveys'],
        permissions: [],
      },
    ],
  },
  {
    name: 'Performance',
    value: 'performance',
    description: 'View performance data',
    tabs: [
      {
        name: 'Performance',
        value: 'performance-overview',
        description: 'View performance data for your campaigns',
        permissions: [],
      },
    ],
  },
];